import { theme } from 'theme'
import styled from 'particles/themes/styled'

export const RegisterContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    position: relative;
    .form-field {
        display: flex;
        flex-direction: column;
        gap: ${theme.newSpacing.l};
        margin-top: ${theme.newSpacing.xl};
        padding: 0 ${theme.newSpacing.l} ${theme.newSpacing.l};
        @media screen and (max-width: 768px) {
            padding: ${theme.newSpacing.s} ${theme.newSpacing.s} 160px;
        }
    }
    .brands-list {
        width: 495px;
    }
    .form-title {
        padding: ${theme.newSpacing.l} ${theme.newSpacing.l} 0;
        .first-divider {
            margin-top: ${theme.newSpacing.m};
        }
    }
    .first-divider {
        margin-top: ${theme.newSpacing.m};
    }
    background-color: ${theme.newColors.neutral50};

    .register-input-area,
    .auto-update-input-area {
        margin-top: ${theme.newSpacing.l};
    }
    .button-group {
        width: 100%;
        position: sticky;
        bottom: 0;
        background-color: ${theme.newColors.neutral50};
        box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.06);
        padding: 14px ${theme.newSpacing.l};
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        gap: ${theme.newSpacing.l};
        z-index: 200;
        @media screen and (max-width: 768px) {
            width: calc(100% - 16px);
            left: 50%;
            bottom: 0;
            position: fixed;
            transform: translateX(-50%);
        }
    }
`
